<!--
  This component serves as a responsive container for sections.
  It applies consistent horizontal margins and centers its content.
  On larger screens, it sets a maximum width for better layout control.
-->
<script setup lang="ts">
type Props = {
  hasNoMobileMargins?: boolean
  takesFullScreenWidth?: boolean
}

const { hasNoMobileMargins = false, takesFullScreenWidth = false } =
  defineProps<Props>()
</script>

<template>
  <div
    class="tw-flex tw-justify-center"
    :class="[
      {
        'tw-mx-lg md:tw-mx-xl': !hasNoMobileMargins,
      },
      takesFullScreenWidth
        ? 'tw-mx-0 min-[1280px]:tw-mx-0 min-[1280px]:tw-max-w-full'
        : 'min-[1280px]:tw-mx-auto min-[1280px]:tw-max-w-[1200px]',
    ]"
  >
    <slot />
  </div>
</template>
